import { Component } from "@angular/core"

@Component({
  selector: 'alert-banner',
  template: `
    <div class="alert alert-warning text-center mb-0" role="alert">
      <ng-content></ng-content>
    </div>
  `
})
export class AlertBanner {}
